import buildTheme from "./buildTheme";

const lightTheme = buildTheme('light');

export default lightTheme;
